(function () {
  "use strict";

  var CASIO_VENDOR_NAME = "CASIO";

  // Any one of these may be given as the free gift. They are tried in
  // order and the first one that is actually in stock gets added.
  var GIFT_VARIANT_IDS = [
    "55738812825892",
    "55738833699108"
  ];

  var isSyncing = false;
  var debouncedSync;
  var originalFetch = window.fetch;

  function getRequest() {
    return originalFetch || window.fetch;
  }

  function getConfiguredGiftVariantIds() {
    var ids = [];
    var seenIds = {};

    for (var i = 0; i < GIFT_VARIANT_IDS.length; i++) {
      var variantId = String(GIFT_VARIANT_IDS[i] || "").trim();

      if (!variantId || seenIds[variantId]) {
        continue;
      }

      seenIds[variantId] = true;
      ids.push(variantId);
    }

    return ids;
  }

  function getVariantId(line) {
    if (!line) {
      return "";
    }

    return String(line.variant_id || line.id || "");
  }

  function getLineKey(line) {
    if (!line) {
      return "";
    }

    return line.key || line.id || "";
  }

  function isCasioLine(line) {
    var vendor = line && line.vendor;

    if (!vendor && line && line.product) {
      vendor = line.product.vendor;
    }

    return Boolean(vendor && String(vendor).toUpperCase() === CASIO_VENDOR_NAME);
  }

  function isConfiguredGift(line, giftVariantIdSet) {
    return giftVariantIdSet[getVariantId(line)] === true;
  }

  function createIdSet(ids) {
    var idSet = {};

    for (var i = 0; i < ids.length; i++) {
      idSet[String(ids[i])] = true;
    }

    return idSet;
  }

  function isLineDiscounted(line) {
    if (line.original_line_price != null && line.final_line_price != null) {
      return parseFloat(line.original_line_price) > parseFloat(line.final_line_price);
    }

    return false;
  }

  function hasFullPriceCasioWatch(cart, giftVariantIdSet) {
    if (!cart || !Array.isArray(cart.items)) {
      return false;
    }

    for (var i = 0; i < cart.items.length; i++) {
      var line = cart.items[i];

      if (!isCasioLine(line) || isConfiguredGift(line, giftVariantIdSet) || isLineDiscounted(line)) {
        continue;
      }

      return true;
    }

    return false;
  }

  function findConfiguredGiftLines(cart, giftVariantIdSet) {
    var giftLines = [];

    if (!cart || !Array.isArray(cart.items)) {
      return giftLines;
    }

    for (var i = 0; i < cart.items.length; i++) {
      var line = cart.items[i];

      if (isConfiguredGift(line, giftVariantIdSet)) {
        giftLines.push(line);
      }
    }

    return giftLines;
  }

  async function fetchCart() {
    var response = await getRequest()("/cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error("Failed to fetch cart: " + response.status);
    }

    return response.json();
  }

  // Tries each configured gift variant in order and adds the first one
  // that is actually available (in stock). Returns the variant id that
  // was added, or null if none of them could be added.
  async function addFirstAvailableGift(variantIds) {
    for (var i = 0; i < variantIds.length; i++) {
      var variantId = variantIds[i];

      try {
        var response = await getRequest()("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }]
          })
        });

        if (response.ok) {
          return variantId;
        }
      } catch (error) {
        // Network error - try the next configured gift.
      }
    }

    return null;
  }

  async function updateCartLines(updates) {
    if (!updates.length) {
      return null;
    }

    var updatesObject = {};

    for (var i = 0; i < updates.length; i++) {
      updatesObject[updates[i].id] = updates[i].quantity;
    }

    var response = await getRequest()("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        updates: updatesObject
      })
    });

    if (!response.ok) {
      var errorData = await response.json().catch(function () {
        return { message: "Unknown error" };
      });
      throw new Error("Failed to update Casio gift products: " + JSON.stringify(errorData));
    }

    return response.json();
  }

  function updateCartCount(cart) {
    var itemCount = cart && cart.item_count ? cart.item_count : 0;

    if (typeof window.updateCartCount === "function") {
      window.updateCartCount(itemCount);
    }

    var cartCountElements = document.querySelectorAll("[data-cart-count]");

    for (var i = 0; i < cartCountElements.length; i++) {
      cartCountElements[i].textContent = itemCount;
      cartCountElements[i].setAttribute("data-cart-count", itemCount);
    }
  }

  function triggerCartRefresh() {
    if (window.themeCore && window.themeCore.EventBus) {
      window.themeCore.EventBus.emit("cart:refresh");
    }

    window.dispatchEvent(new CustomEvent("casio-free-gift:synced"));
  }

  async function syncFreeGiftWithCart() {
    if (isSyncing) {
      return;
    }

    var giftVariantIds = getConfiguredGiftVariantIds();

    if (!giftVariantIds.length) {
      return;
    }

    var giftVariantIdSet = createIdSet(giftVariantIds);

    isSyncing = true;

    try {
      var cart = await fetchCart();
      var shouldHaveGift = hasFullPriceCasioWatch(cart, giftVariantIdSet);
      var giftLines = findConfiguredGiftLines(cart, giftVariantIdSet);
      var updates = [];
      var keepingExistingGift = false;

      for (var i = 0; i < giftLines.length; i++) {
        var giftLine = giftLines[i];
        var lineKey = getLineKey(giftLine);

        if (!lineKey) {
          continue;
        }

        if (!shouldHaveGift) {
          updates.push({ id: lineKey, quantity: 0 });
          continue;
        }

        // Only one gift line is allowed at a time - keep the first one
        // found and drop any duplicates/other configured gift.
        if (keepingExistingGift) {
          updates.push({ id: lineKey, quantity: 0 });
          continue;
        }

        keepingExistingGift = true;

        if (parseInt(giftLine.quantity || 1, 10) !== 1) {
          updates.push({ id: lineKey, quantity: 1 });
        }
      }

      if (updates.length) {
        await updateCartLines(updates);
      }

      var addedGiftVariantId = null;

      if (shouldHaveGift && !keepingExistingGift) {
        addedGiftVariantId = await addFirstAvailableGift(giftVariantIds);

        if (!addedGiftVariantId) {
          console.error("[Casio Free Gift] None of the configured gift variants are available to add.");
        }
      }

      if (updates.length || addedGiftVariantId) {
        cart = await fetchCart();
        updateCartCount(cart);
        triggerCartRefresh();
      }
    } catch (error) {
      console.error("[Casio Free Gift] Error syncing free gift:", error);
    } finally {
      isSyncing = false;
    }
  }

  function debounce(func, wait) {
    var timeout;

    return function () {
      var context = this;
      var args = arguments;

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    };
  }

  debouncedSync = debounce(syncFreeGiftWithCart, 150);

  function setupFetchHook() {
    if (!originalFetch) {
      return;
    }

    window.fetch = function () {
      var url = arguments[0];
      var options = arguments[1] || {};

      if (typeof url !== "string") {
        return originalFetch.apply(this, arguments);
      }

      var method = (options.method || "GET").toUpperCase();
      var isCartMutation =
        url.indexOf("/cart/add") !== -1 ||
        url.indexOf("/cart/change") !== -1 ||
        url.indexOf("/cart/update") !== -1 ||
        (url.indexOf("/cart.js") !== -1 && method === "POST");

      var fetchPromise = originalFetch.apply(this, arguments);

      if (isCartMutation) {
        fetchPromise
          .then(function (response) {
            if (response.ok) {
              debouncedSync();
            }
          })
          .catch(function () {
            debouncedSync();
          });
      }

      return fetchPromise;
    };
  }

  function setupFormHooks() {
    document.addEventListener("submit", function (event) {
      var form = event.target;

      if (!form || form.tagName !== "FORM") {
        return;
      }

      var action = form.action || "";
      var method = (form.method || "POST").toUpperCase();

      if (
        action.indexOf("/cart/add") !== -1 ||
        action.indexOf("cart/add") !== -1 ||
        (method === "POST" && form.querySelector('input[name="id"], select[name="id"]'))
      ) {
        debouncedSync();
      }
    }, true);
  }

  function setupQuantityHooks() {
    document.addEventListener("change", function (event) {
      var target = event.target;

      if (!target || target.tagName !== "INPUT") {
        return;
      }

      var className = target.className || "";

      if (
        (target.type === "number" || target.type === "text") &&
        (target.name === "quantity" || className.indexOf("quantity") !== -1)
      ) {
        debouncedSync();
      }
    }, true);

    document.addEventListener("click", function (event) {
      var button = event.target && event.target.closest("button, a");

      if (!button) {
        return;
      }

      var className = button.className || "";
      var dataAction = button.getAttribute("data-action") || button.getAttribute("data-cart-action") || "";
      var ariaLabel = button.getAttribute("aria-label") || "";

      if (
        className.indexOf("cart-quantity") !== -1 ||
        className.indexOf("quantity-button") !== -1 ||
        dataAction.indexOf("cart") !== -1 ||
        ariaLabel.toLowerCase().indexOf("quantity") !== -1
      ) {
        debouncedSync();
      }
    }, true);
  }

  function setupEventListeners() {
    if (window.themeCore && window.themeCore.EventBus) {
      window.themeCore.EventBus.on("cart:updated", debouncedSync);
      window.themeCore.EventBus.on("cart:change", debouncedSync);
    }

    window.addEventListener("cart:updated", debouncedSync);
    window.addEventListener("cart:change", debouncedSync);
  }

  function init() {
    setupFetchHook();
    setupFormHooks();
    setupQuantityHooks();
    setupEventListeners();
    debouncedSync();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.casioFreeGiftSync = syncFreeGiftWithCart;
})();
